module.exports = __webpack_public_path__ + "img/shild.bc914555.png";